import { render } from "./gbyunying.vue?vue&type=template&id=c02166f4&scoped=true"
import script from "./gbyunying.vue?vue&type=script&lang=js"
export * from "./gbyunying.vue?vue&type=script&lang=js"

import "./gbyunying.vue?vue&type=style&index=0&id=c02166f4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-c02166f4"

export default script